import { render } from "./BudgetDeliveryUpdate.vue?vue&type=template&id=9538458a&scoped=true"
import script from "./BudgetDeliveryUpdate.vue?vue&type=script&lang=js"
export * from "./BudgetDeliveryUpdate.vue?vue&type=script&lang=js"

import "./BudgetDeliveryUpdate.vue?vue&type=style&index=0&id=9538458a&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9538458a"]])

export default __exports__